import React from 'react';
import './LenderDashboard.css'; // Import CSS for styling

const LenderDashboard = ({ results }) => {

    const handleExport = () => {
        const csvRows = [];
        const headers = ['Lender Name', 'Completed Audits', 'Jobs MTD', 'Estimated Monthly Jobs', 'Estimated Audits Still Required'];
        csvRows.push(headers.join(',')); // Add headers to CSV
    
        // Add data rows
        Object.entries(results).forEach(([lenderName, data]) => {
          const row = [
            lenderName,
            data.completed,
            data.jobs_mtd,
            data.estimated_monthly_jobs,
            data.estimated_audits_still_required,
          ];
          csvRows.push(row.join(','));
        });
    
        // Create a Blob and download the file
        const csvContent = csvRows.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'lender_audits.csv';
        link.click();
        URL.revokeObjectURL(url); // Clean up the URL object
      };
    return (
        <div className="dashboard-container">
        <h2>Lender Audits</h2>
        <button className="export-button" onClick={handleExport}>
            Export to CSV
        </button>
        <div className="scrollable-table-container">
            <table className="dashboard-table">
            <thead>
                <tr>
                <th>Lender Name</th>
                <th>Completed Audits</th>
                <th>Jobs MTD</th>
                <th>Estimated Monthly Jobs</th>
                <th>Estimated Audits Still Required</th>
                </tr>
            </thead>
            <tbody>
                {Object.entries(results).map(([lenderName, data]) => (
                <tr key={lenderName}>
                    <td>{lenderName}</td>
                    <td>{data.completed}</td>
                    <td>{data.jobs_mtd}</td>
                    <td>{data.estimated_monthly_jobs}</td>
                    <td>{data.estimated_audits_still_required}</td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
        </div>
    );
};

export default LenderDashboard;